import {useEffect, useRef, useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {supportCentreContentFor} from './content';

const SupportCentre = () => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const {collectionUrl, articles} = supportCentreContentFor(window.location.pathname);

  useEffect(() => {
    if (!isOpen) return;

    function handleClickOutside(event) {
      if (!containerRef.current.contains(event.target)) setIsOpen(false);
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <>
      <div ref={containerRef} className='flex items-center h-full relative'>
        <div className='cursor-pointer select-none' onClick={() => setIsOpen(!isOpen)}>
          <i className={`material-symbols-${isOpen ? 'solid' : 'outlined'} text-white h1 align-middle`}>{'help'}</i>
        </div>
        {isOpen && <div className='absolute top-full right-0 rounded box-shadow-2 bg-white border w-[300px] p-4'>
          <div className='text-center'>
            <a className='inline-flex items-center'
              href={collectionUrl}
              target='_blank'
              rel='noreferrer'>
              <FormattedMessage id='components.support_centre.Visit Support Centre'/>
              <i className='material-symbols-outlined h3 ml1 align-middle'>{'open_in_new'}</i>
            </a>
          </div>
          {articles.length > 0 && <>
            <hr />
            <div className='space-y-2'>
              <div className='waterloo'>
                <FormattedMessage id='components.support_centre.Suggested Links'/>
              </div>
              {articles.map(({id, titleKey, url}) => <div key={id}>
                <a href={url} target='_blank' rel='noreferrer'>
                  <FormattedMessage id={titleKey} />
                </a>
              </div>)}
            </div>
          </>
          }
        </div>
        }
      </div>
    </>
  );
};

export default SupportCentre;
